import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import Player from '@/game/prefabs/World/Player';
export class CameraController {
  scene: Phaser.Scene;
  tilemap: Phaser.Tilemaps.Tilemap;
  player: Player;
  camera: Phaser.Cameras.Scene2D.Camera;
  cameraBounds: { x: number; y: number; width: number; height: number };

  lastLeftOverlap: number = 0;
  lastRightOverlap: number = 0;
  lastTopOverlap: number = 0;
  lastBottomOverlap: number = 0;

  wasMobileLastFrame: boolean = false;

  constructor(data: any) {
    this.scene = data.scene;
    this.tilemap = data.tilemap;
    this.player = data.player;
    this.camera = data.camera;
    this.cameraBounds = {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
    };
  }

  initialize() {
    const { cameraBounds } = this;

    cameraBounds.width = this.tilemap.widthInPixels;
    cameraBounds.height = this.tilemap.heightInPixels;

    if (!cameraBounds.width || !cameraBounds.height) {
      console.error('Invalid portal positions');
    }

    // Call computeLevelConfig to store the configuration in the instance
    // this.computeLevelConfig();

    this.camera.setBounds(
      cameraBounds.x,
      cameraBounds.y,
      cameraBounds.width,
      cameraBounds.height,
    );
    this.scene.cameras.main.setBounds(
      cameraBounds.x,
      cameraBounds.y,
      cameraBounds.width,
      cameraBounds.height,
    );

    this.camera.startFollow(this.player, true, 0.05, 0.05);
    this.camera.setLerp(0.1, 0.1);
    this.camera.setZoom(3);

    this.camera.centerOn(this.player.x, this.player.y);

    this.scene.events.once('postupdate', () => {
      CameraController.adjustCameraZoomToFitBounds(this.camera, {
        x: 0,
        y: 0,
        width: this.tilemap.widthInPixels,
        height: this.tilemap.heightInPixels,
      });
    });

    this.scene.events.on('postupdate', () => {
      this.adjustZoomForDevice();
    });

    return this;
  }

  adjustZoomForDevice() {
    const isMobile = ResponsivenessManager.IsMobileDevice(this.scene);

    this.camera.setZoom(isMobile ? 1.5 : 3);

    if (!this.wasMobileLastFrame !== isMobile) {
      // We switched device.
      CameraController.adjustCameraZoomToFitBounds(this.camera, {
        x: 0,
        y: 0,
        width: this.tilemap.widthInPixels,
        height: this.tilemap.heightInPixels,
      });
    }
    this.wasMobileLastFrame = isMobile;
  }

  static async adjustCameraZoomToFitBounds(
    camera: Phaser.Cameras.Scene2D.Camera,
    worldBounds: { x: number; y: number; width: number; height: number },
  ) {
    function doesCameraOverlapBounds(cameraDisplay: any, worldBounds: any) {
      return (cameraDisplay.x < worldBounds.x ||
        cameraDisplay.x + cameraDisplay.width >
          worldBounds.x + worldBounds.width ||
        cameraDisplay.y < worldBounds.y ||
        cameraDisplay.y + cameraDisplay.height >
          worldBounds.y + worldBounds.height) as boolean;
    }

    let cameraRect = {
      x: camera.x,
      y: camera.y,
      width: camera.width,
      height: camera.height,
    };

    let cameraDisplay = {
      x: 0,
      y: 0,
      width: cameraRect.width / camera.zoom,
      height: cameraRect.height / camera.zoom,
    };

    let zoom = camera.zoom;

    let overlaps = doesCameraOverlapBounds(cameraDisplay, worldBounds);
    while (overlaps && zoom < 5) {
      zoom += 0.2;
      const newDisplay = {
        x: 0,
        y: 0,
        width: cameraRect.width / zoom,
        height: cameraRect.height / zoom,
      };
      overlaps = doesCameraOverlapBounds(newDisplay, worldBounds);
    }
    camera.setZoom(zoom);
  }
}
